import { render } from "./ConfirmView.vue?vue&type=template&id=74604ac6&scoped=true"
import script from "./ConfirmView.vue?vue&type=script&lang=js"
export * from "./ConfirmView.vue?vue&type=script&lang=js"

import "./ConfirmView.vue?vue&type=style&index=0&id=74604ac6&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74604ac6"]])

export default __exports__